import React from 'react';
import classNames from 'classnames';
import { Grid, Typography } from '@mui/material';

import quickTipElement from 'utils/quickTipsUtils';

import Styles from './TravelQuickTips.module.scss';

export interface TravelQuickTipsProps {
  averageCost: string;
  cashCardCrypto: string;
  colorPalette: {
    primary: string;
    secondary: string;
    accent: string;
  };
  connectivity: string;
  currency: string;
  drinkingWaterQuality: string;
  hazards: string;
  travelTimes: string;
  visaRequirements: string;
}

export const TravelQuickTips: React.FC<TravelQuickTipsProps> = ({
  averageCost,
  cashCardCrypto,
  colorPalette,
  connectivity,
  currency,
  drinkingWaterQuality,
  hazards,
  travelTimes,
  visaRequirements,
}) => {
  if (
    !averageCost &&
    !cashCardCrypto &&
    !connectivity &&
    !currency &&
    !drinkingWaterQuality &&
    !hazards &&
    !travelTimes &&
    !visaRequirements
  ) {
    return <div />;
  }

  const data = {
    travelTimes,
    connectivity,
    currency,
    averageCost,
    visaRequirements,
    drinkingWaterQuality,
    hazards,
    cashCardCrypto,
  };
  const quickTipsData = Object.entries(data).map(([key, val]) => quickTipElement(key, val));

  return (
    <section
      className={classNames(Styles.quickTips, 'sl-section-container')}
      data-testid="travel-zone-quick-tips"
      style={{
        // @ts-ignore
        '--color-palette-primary': colorPalette.primary,
        '--color-palette-secondary': colorPalette.secondary,
        '--color-palette-accent': colorPalette.accent,
      }}
    >
      <div className={Styles.wrapper}>
        <div className={Styles.titleWrap}>
          <Typography variant="title2" className={Styles.title}>
            Quick Tips
          </Typography>
        </div>
        <Grid container spacing={{ mobile: 2, tablet: 3 }}>
          {quickTipsData.length
            ? quickTipsData.map((props) => {
                if (!props?.icon || !props?.title || !props?.content) {
                  return null;
                }

                const { icon: Icon, title, content } = props;

                return (
                  <Grid
                    item
                    mobile={12}
                    tablet={6}
                    tabletLg={4}
                    desktop={3}
                    className={Styles.gridItem}
                    key={title}
                  >
                    <Icon colorPalette={colorPalette} />
                    <Typography variant="headline" component="h3" className={Styles.headline}>
                      {title}
                    </Typography>
                    {content.length
                      ? content.map((text: string) => (
                          <Typography variant="body" className={Styles.body} key={text}>
                            {text}
                          </Typography>
                        ))
                      : null}
                  </Grid>
                );
              })
            : null}
        </Grid>
      </div>
    </section>
  );
};

export default TravelQuickTips;
